import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import _ from 'lodash'; // ------------------------------

var state = {
  lastn: 20
}; // ------------------------------

var getters = {
  chunkedEntries: function chunkedEntries(state) {
    return function (list) {
      try {
        return _.chunk(list, state.lastn);
      } catch (error) {
        return [];
      }
    };
  }
}; // ------------------------------

var mutations = {}; // ------------------------------

var actions = {
  LIST: function LIST(_ref, endpoint) {
    var rootState = _ref.rootState;
    return _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _ref2, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return rootState.api.get(endpoint, {
                params: {
                  datetime: Date.now()
                }
              });

            case 3:
              _ref2 = _context.sent;
              data = _ref2.data;

              if (!_.isObject(data)) {
                _context.next = 10;
                break;
              }

              _.map(data.items, function (i) {
                if (i.customFields) {
                  i.customFields = _.keyBy(i.customFields, 'basename');
                }
              });

              return _context.abrupt("return", data);

            case 10:
              return _context.abrupt("return", []);

            case 11:
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", []);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }))();
  },
  DETAIL: function DETAIL(_ref3, endpoint) {
    var rootState = _ref3.rootState;
    return _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var _ref4, data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return rootState.api.get(endpoint, {
                params: {
                  datetime: Date.now()
                }
              });

            case 3:
              _ref4 = _context2.sent;
              data = _ref4.data;
              return _context2.abrupt("return", data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", []);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }))();
  }
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};